import AMapLoader from '@amap/amap-jsapi-loader'

const securityJsCode = process.env.VUE_APP_AMAP_SECURITY_CODE

window._AMapSecurityConfig = {
  securityJsCode: securityJsCode
}

const aMapKey = process.env.VUE_APP_AMAP_KEY 

// 初始化地图
const aMap = async () => {
  const initMap = await AMapLoader.load({
    key: aMapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [
      // 'AMap.Scale',
      'AMap.Geolocation',
      // 'CitySearch',
      'AMap.Geocoder',
      'AMap.convertFrom',
    ] //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
  })
  return initMap
}

const location = async () => {
  const AMap = await aMap();
  const geolocation = new AMap.Geolocation({
    enableHighAccuracy: true,
    timeout: 10000,
    convert: false
  })
  return geolocation
}

const SearchCity = async (cityName = '') => {
  const AMap = await aMap();
  const citySearch = new AMap.Geocoder();

  return citySearch
}

const getCityconvertFrom = async ({
  lat,
  lng
}) => {
  const Amap = await aMap();
  const convertFrom = new Amap.convertFrom(
      `${lng},${lat}`,
      (status, result) => {
        console.log(status, result)
        resolve(status, result)
      }
    )
    return convertFrom
}

export { aMap, location, SearchCity, getCityconvertFrom }
